// packages/alpinejs/src/scheduler.js
var $bf0aa42b5f3ddd7c$var$flushPending = false;
var $bf0aa42b5f3ddd7c$var$flushing = false;
var $bf0aa42b5f3ddd7c$var$queue = [];
var $bf0aa42b5f3ddd7c$var$lastFlushedIndex = -1;
var $bf0aa42b5f3ddd7c$var$transactionActive = false;
function $bf0aa42b5f3ddd7c$var$scheduler(callback) {
    $bf0aa42b5f3ddd7c$var$queueJob(callback);
}
function $bf0aa42b5f3ddd7c$var$startTransaction() {
    $bf0aa42b5f3ddd7c$var$transactionActive = true;
}
function $bf0aa42b5f3ddd7c$var$commitTransaction() {
    $bf0aa42b5f3ddd7c$var$transactionActive = false;
    $bf0aa42b5f3ddd7c$var$queueFlush();
}
function $bf0aa42b5f3ddd7c$var$queueJob(job) {
    if (!$bf0aa42b5f3ddd7c$var$queue.includes(job)) $bf0aa42b5f3ddd7c$var$queue.push(job);
    $bf0aa42b5f3ddd7c$var$queueFlush();
}
function $bf0aa42b5f3ddd7c$var$dequeueJob(job) {
    let index = $bf0aa42b5f3ddd7c$var$queue.indexOf(job);
    if (index !== -1 && index > $bf0aa42b5f3ddd7c$var$lastFlushedIndex) $bf0aa42b5f3ddd7c$var$queue.splice(index, 1);
}
function $bf0aa42b5f3ddd7c$var$queueFlush() {
    if (!$bf0aa42b5f3ddd7c$var$flushing && !$bf0aa42b5f3ddd7c$var$flushPending) {
        if ($bf0aa42b5f3ddd7c$var$transactionActive) return;
        $bf0aa42b5f3ddd7c$var$flushPending = true;
        queueMicrotask($bf0aa42b5f3ddd7c$var$flushJobs);
    }
}
function $bf0aa42b5f3ddd7c$var$flushJobs() {
    $bf0aa42b5f3ddd7c$var$flushPending = false;
    $bf0aa42b5f3ddd7c$var$flushing = true;
    for(let i = 0; i < $bf0aa42b5f3ddd7c$var$queue.length; i++){
        $bf0aa42b5f3ddd7c$var$queue[i]();
        $bf0aa42b5f3ddd7c$var$lastFlushedIndex = i;
    }
    $bf0aa42b5f3ddd7c$var$queue.length = 0;
    $bf0aa42b5f3ddd7c$var$lastFlushedIndex = -1;
    $bf0aa42b5f3ddd7c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $bf0aa42b5f3ddd7c$var$reactive;
var $bf0aa42b5f3ddd7c$var$effect;
var $bf0aa42b5f3ddd7c$var$release;
var $bf0aa42b5f3ddd7c$var$raw;
var $bf0aa42b5f3ddd7c$var$shouldSchedule = true;
function $bf0aa42b5f3ddd7c$var$disableEffectScheduling(callback) {
    $bf0aa42b5f3ddd7c$var$shouldSchedule = false;
    callback();
    $bf0aa42b5f3ddd7c$var$shouldSchedule = true;
}
function $bf0aa42b5f3ddd7c$var$setReactivityEngine(engine) {
    $bf0aa42b5f3ddd7c$var$reactive = engine.reactive;
    $bf0aa42b5f3ddd7c$var$release = engine.release;
    $bf0aa42b5f3ddd7c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($bf0aa42b5f3ddd7c$var$shouldSchedule) $bf0aa42b5f3ddd7c$var$scheduler(task);
                else task();
            }
        });
    $bf0aa42b5f3ddd7c$var$raw = engine.raw;
}
function $bf0aa42b5f3ddd7c$var$overrideEffect(override) {
    $bf0aa42b5f3ddd7c$var$effect = override;
}
function $bf0aa42b5f3ddd7c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $bf0aa42b5f3ddd7c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $bf0aa42b5f3ddd7c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $bf0aa42b5f3ddd7c$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $bf0aa42b5f3ddd7c$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        firstTime = false;
    });
    return ()=>$bf0aa42b5f3ddd7c$var$release(effectReference);
}
async function $bf0aa42b5f3ddd7c$var$transaction(callback) {
    $bf0aa42b5f3ddd7c$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $bf0aa42b5f3ddd7c$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $bf0aa42b5f3ddd7c$var$onAttributeAddeds = [];
var $bf0aa42b5f3ddd7c$var$onElRemoveds = [];
var $bf0aa42b5f3ddd7c$var$onElAddeds = [];
function $bf0aa42b5f3ddd7c$var$onElAdded(callback) {
    $bf0aa42b5f3ddd7c$var$onElAddeds.push(callback);
}
function $bf0aa42b5f3ddd7c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $bf0aa42b5f3ddd7c$var$onElRemoveds.push(callback);
    }
}
function $bf0aa42b5f3ddd7c$var$onAttributesAdded(callback) {
    $bf0aa42b5f3ddd7c$var$onAttributeAddeds.push(callback);
}
function $bf0aa42b5f3ddd7c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $bf0aa42b5f3ddd7c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $bf0aa42b5f3ddd7c$var$cleanupElement(el) {
    el._x_effects?.forEach($bf0aa42b5f3ddd7c$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $bf0aa42b5f3ddd7c$var$observer = new MutationObserver($bf0aa42b5f3ddd7c$var$onMutate);
var $bf0aa42b5f3ddd7c$var$currentlyObserving = false;
function $bf0aa42b5f3ddd7c$var$startObservingMutations() {
    $bf0aa42b5f3ddd7c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $bf0aa42b5f3ddd7c$var$currentlyObserving = true;
}
function $bf0aa42b5f3ddd7c$var$stopObservingMutations() {
    $bf0aa42b5f3ddd7c$var$flushObserver();
    $bf0aa42b5f3ddd7c$var$observer.disconnect();
    $bf0aa42b5f3ddd7c$var$currentlyObserving = false;
}
var $bf0aa42b5f3ddd7c$var$queuedMutations = [];
function $bf0aa42b5f3ddd7c$var$flushObserver() {
    let records = $bf0aa42b5f3ddd7c$var$observer.takeRecords();
    $bf0aa42b5f3ddd7c$var$queuedMutations.push(()=>records.length > 0 && $bf0aa42b5f3ddd7c$var$onMutate(records));
    let queueLengthWhenTriggered = $bf0aa42b5f3ddd7c$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($bf0aa42b5f3ddd7c$var$queuedMutations.length === queueLengthWhenTriggered) while($bf0aa42b5f3ddd7c$var$queuedMutations.length > 0)$bf0aa42b5f3ddd7c$var$queuedMutations.shift()();
    });
}
function $bf0aa42b5f3ddd7c$var$mutateDom(callback) {
    if (!$bf0aa42b5f3ddd7c$var$currentlyObserving) return callback();
    $bf0aa42b5f3ddd7c$var$stopObservingMutations();
    let result = callback();
    $bf0aa42b5f3ddd7c$var$startObservingMutations();
    return result;
}
var $bf0aa42b5f3ddd7c$var$isCollecting = false;
var $bf0aa42b5f3ddd7c$var$deferredMutations = [];
function $bf0aa42b5f3ddd7c$var$deferMutations() {
    $bf0aa42b5f3ddd7c$var$isCollecting = true;
}
function $bf0aa42b5f3ddd7c$var$flushAndStopDeferringMutations() {
    $bf0aa42b5f3ddd7c$var$isCollecting = false;
    $bf0aa42b5f3ddd7c$var$onMutate($bf0aa42b5f3ddd7c$var$deferredMutations);
    $bf0aa42b5f3ddd7c$var$deferredMutations = [];
}
function $bf0aa42b5f3ddd7c$var$onMutate(mutations) {
    if ($bf0aa42b5f3ddd7c$var$isCollecting) {
        $bf0aa42b5f3ddd7c$var$deferredMutations = $bf0aa42b5f3ddd7c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $bf0aa42b5f3ddd7c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $bf0aa42b5f3ddd7c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $bf0aa42b5f3ddd7c$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $bf0aa42b5f3ddd7c$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $bf0aa42b5f3ddd7c$var$scope(node) {
    return $bf0aa42b5f3ddd7c$var$mergeProxies($bf0aa42b5f3ddd7c$var$closestDataStack(node));
}
function $bf0aa42b5f3ddd7c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$bf0aa42b5f3ddd7c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $bf0aa42b5f3ddd7c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $bf0aa42b5f3ddd7c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $bf0aa42b5f3ddd7c$var$closestDataStack(node.parentNode);
}
function $bf0aa42b5f3ddd7c$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $bf0aa42b5f3ddd7c$var$mergeProxyTrap);
}
var $bf0aa42b5f3ddd7c$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $bf0aa42b5f3ddd7c$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $bf0aa42b5f3ddd7c$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $bf0aa42b5f3ddd7c$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $bf0aa42b5f3ddd7c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$bf0aa42b5f3ddd7c$var$get(data2, path), (value)=>$bf0aa42b5f3ddd7c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $bf0aa42b5f3ddd7c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $bf0aa42b5f3ddd7c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $bf0aa42b5f3ddd7c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $bf0aa42b5f3ddd7c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $bf0aa42b5f3ddd7c$var$magics = {};
function $bf0aa42b5f3ddd7c$var$magic(name, callback) {
    $bf0aa42b5f3ddd7c$var$magics[name] = callback;
}
function $bf0aa42b5f3ddd7c$var$injectMagics(obj, el) {
    let memoizedUtilities = $bf0aa42b5f3ddd7c$var$getUtilities(el);
    Object.entries($bf0aa42b5f3ddd7c$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $bf0aa42b5f3ddd7c$var$getUtilities(el) {
    let [utilities, cleanup2] = $bf0aa42b5f3ddd7c$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $bf0aa42b5f3ddd7c$var$interceptor,
        ...utilities
    };
    $bf0aa42b5f3ddd7c$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $bf0aa42b5f3ddd7c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $bf0aa42b5f3ddd7c$var$handleError(e, el, expression);
    }
}
function $bf0aa42b5f3ddd7c$var$handleError(...args) {
    return $bf0aa42b5f3ddd7c$var$errorHandler(...args);
}
var $bf0aa42b5f3ddd7c$var$errorHandler = $bf0aa42b5f3ddd7c$var$normalErrorHandler;
function $bf0aa42b5f3ddd7c$var$setErrorHandler(handler4) {
    $bf0aa42b5f3ddd7c$var$errorHandler = handler4;
}
function $bf0aa42b5f3ddd7c$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $bf0aa42b5f3ddd7c$var$shouldAutoEvaluateFunctions = true;
function $bf0aa42b5f3ddd7c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $bf0aa42b5f3ddd7c$var$shouldAutoEvaluateFunctions;
    $bf0aa42b5f3ddd7c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $bf0aa42b5f3ddd7c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $bf0aa42b5f3ddd7c$var$evaluate(el, expression, extras = {}) {
    let result;
    $bf0aa42b5f3ddd7c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $bf0aa42b5f3ddd7c$var$evaluateLater(...args) {
    return $bf0aa42b5f3ddd7c$var$theEvaluatorFunction(...args);
}
var $bf0aa42b5f3ddd7c$var$theEvaluatorFunction = $bf0aa42b5f3ddd7c$var$normalEvaluator;
function $bf0aa42b5f3ddd7c$var$setEvaluator(newEvaluator) {
    $bf0aa42b5f3ddd7c$var$theEvaluatorFunction = newEvaluator;
}
var $bf0aa42b5f3ddd7c$var$theRawEvaluatorFunction;
function $bf0aa42b5f3ddd7c$var$setRawEvaluator(newEvaluator) {
    $bf0aa42b5f3ddd7c$var$theRawEvaluatorFunction = newEvaluator;
}
function $bf0aa42b5f3ddd7c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $bf0aa42b5f3ddd7c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$bf0aa42b5f3ddd7c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $bf0aa42b5f3ddd7c$var$generateEvaluatorFromFunction(dataStack, expression) : $bf0aa42b5f3ddd7c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $bf0aa42b5f3ddd7c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $bf0aa42b5f3ddd7c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$bf0aa42b5f3ddd7c$var$shouldAutoEvaluateFunctions) {
            $bf0aa42b5f3ddd7c$var$runIfTypeOfFunction(receiver, func, $bf0aa42b5f3ddd7c$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($bf0aa42b5f3ddd7c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $bf0aa42b5f3ddd7c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $bf0aa42b5f3ddd7c$var$evaluatorMemo = {};
function $bf0aa42b5f3ddd7c$var$generateFunctionFromString(expression, el) {
    if ($bf0aa42b5f3ddd7c$var$evaluatorMemo[expression]) return $bf0aa42b5f3ddd7c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $bf0aa42b5f3ddd7c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $bf0aa42b5f3ddd7c$var$evaluatorMemo[expression] = func;
    return func;
}
function $bf0aa42b5f3ddd7c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $bf0aa42b5f3ddd7c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $bf0aa42b5f3ddd7c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$bf0aa42b5f3ddd7c$var$handleError(error2, el, expression));
            if (func.finished) {
                $bf0aa42b5f3ddd7c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $bf0aa42b5f3ddd7c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$bf0aa42b5f3ddd7c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $bf0aa42b5f3ddd7c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($bf0aa42b5f3ddd7c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$bf0aa42b5f3ddd7c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$bf0aa42b5f3ddd7c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $bf0aa42b5f3ddd7c$var$evaluateRaw(...args) {
    return $bf0aa42b5f3ddd7c$var$theRawEvaluatorFunction(...args);
}
function $bf0aa42b5f3ddd7c$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $bf0aa42b5f3ddd7c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$bf0aa42b5f3ddd7c$var$closestDataStack(el)
    ];
    let scope2 = $bf0aa42b5f3ddd7c$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $bf0aa42b5f3ddd7c$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $bf0aa42b5f3ddd7c$var$prefixAsString = "x-";
function $bf0aa42b5f3ddd7c$var$prefix(subject = "") {
    return $bf0aa42b5f3ddd7c$var$prefixAsString + subject;
}
function $bf0aa42b5f3ddd7c$var$setPrefix(newPrefix) {
    $bf0aa42b5f3ddd7c$var$prefixAsString = newPrefix;
}
var $bf0aa42b5f3ddd7c$var$directiveHandlers = {};
function $bf0aa42b5f3ddd7c$var$directive(name, callback) {
    $bf0aa42b5f3ddd7c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$bf0aa42b5f3ddd7c$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $bf0aa42b5f3ddd7c$var$directiveOrder.indexOf(directive2);
            $bf0aa42b5f3ddd7c$var$directiveOrder.splice(pos >= 0 ? pos : $bf0aa42b5f3ddd7c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $bf0aa42b5f3ddd7c$var$directiveExists(name) {
    return Object.keys($bf0aa42b5f3ddd7c$var$directiveHandlers).includes(name);
}
function $bf0aa42b5f3ddd7c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $bf0aa42b5f3ddd7c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($bf0aa42b5f3ddd7c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($bf0aa42b5f3ddd7c$var$outNonAlpineAttributes).map($bf0aa42b5f3ddd7c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($bf0aa42b5f3ddd7c$var$byPriority);
    return directives2.map((directive2)=>{
        return $bf0aa42b5f3ddd7c$var$getDirectiveHandler(el, directive2);
    });
}
function $bf0aa42b5f3ddd7c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($bf0aa42b5f3ddd7c$var$toTransformedAttributes()).filter((attr)=>!$bf0aa42b5f3ddd7c$var$outNonAlpineAttributes(attr));
}
var $bf0aa42b5f3ddd7c$var$isDeferringHandlers = false;
var $bf0aa42b5f3ddd7c$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $bf0aa42b5f3ddd7c$var$currentHandlerStackKey = Symbol();
function $bf0aa42b5f3ddd7c$var$deferHandlingDirectives(callback) {
    $bf0aa42b5f3ddd7c$var$isDeferringHandlers = true;
    let key = Symbol();
    $bf0aa42b5f3ddd7c$var$currentHandlerStackKey = key;
    $bf0aa42b5f3ddd7c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($bf0aa42b5f3ddd7c$var$directiveHandlerStacks.get(key).length)$bf0aa42b5f3ddd7c$var$directiveHandlerStacks.get(key).shift()();
        $bf0aa42b5f3ddd7c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $bf0aa42b5f3ddd7c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $bf0aa42b5f3ddd7c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $bf0aa42b5f3ddd7c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $bf0aa42b5f3ddd7c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $bf0aa42b5f3ddd7c$var$evaluateLater.bind($bf0aa42b5f3ddd7c$var$evaluateLater, el),
        evaluate: $bf0aa42b5f3ddd7c$var$evaluate.bind($bf0aa42b5f3ddd7c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $bf0aa42b5f3ddd7c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $bf0aa42b5f3ddd7c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $bf0aa42b5f3ddd7c$var$getElementBoundUtilities(el);
    $bf0aa42b5f3ddd7c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $bf0aa42b5f3ddd7c$var$isDeferringHandlers ? $bf0aa42b5f3ddd7c$var$directiveHandlerStacks.get($bf0aa42b5f3ddd7c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $bf0aa42b5f3ddd7c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $bf0aa42b5f3ddd7c$var$into = (i)=>i;
function $bf0aa42b5f3ddd7c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $bf0aa42b5f3ddd7c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $bf0aa42b5f3ddd7c$var$attributeTransformers = [];
function $bf0aa42b5f3ddd7c$var$mapAttributes(callback) {
    $bf0aa42b5f3ddd7c$var$attributeTransformers.push(callback);
}
function $bf0aa42b5f3ddd7c$var$outNonAlpineAttributes({ name: name }) {
    return $bf0aa42b5f3ddd7c$var$alpineAttributeRegex().test(name);
}
var $bf0aa42b5f3ddd7c$var$alpineAttributeRegex = ()=>new RegExp(`^${$bf0aa42b5f3ddd7c$var$prefixAsString}([^:^.]+)\\b`);
function $bf0aa42b5f3ddd7c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($bf0aa42b5f3ddd7c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $bf0aa42b5f3ddd7c$var$DEFAULT = "DEFAULT";
var $bf0aa42b5f3ddd7c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $bf0aa42b5f3ddd7c$var$DEFAULT,
    "teleport"
];
function $bf0aa42b5f3ddd7c$var$byPriority(a, b) {
    let typeA = $bf0aa42b5f3ddd7c$var$directiveOrder.indexOf(a.type) === -1 ? $bf0aa42b5f3ddd7c$var$DEFAULT : a.type;
    let typeB = $bf0aa42b5f3ddd7c$var$directiveOrder.indexOf(b.type) === -1 ? $bf0aa42b5f3ddd7c$var$DEFAULT : b.type;
    return $bf0aa42b5f3ddd7c$var$directiveOrder.indexOf(typeA) - $bf0aa42b5f3ddd7c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $bf0aa42b5f3ddd7c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $bf0aa42b5f3ddd7c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$bf0aa42b5f3ddd7c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $bf0aa42b5f3ddd7c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $bf0aa42b5f3ddd7c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $bf0aa42b5f3ddd7c$var$started = false;
function $bf0aa42b5f3ddd7c$var$start() {
    if ($bf0aa42b5f3ddd7c$var$started) $bf0aa42b5f3ddd7c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $bf0aa42b5f3ddd7c$var$started = true;
    if (!document.body) $bf0aa42b5f3ddd7c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $bf0aa42b5f3ddd7c$var$dispatch(document, "alpine:init");
    $bf0aa42b5f3ddd7c$var$dispatch(document, "alpine:initializing");
    $bf0aa42b5f3ddd7c$var$startObservingMutations();
    $bf0aa42b5f3ddd7c$var$onElAdded((el)=>$bf0aa42b5f3ddd7c$var$initTree(el, $bf0aa42b5f3ddd7c$var$walk));
    $bf0aa42b5f3ddd7c$var$onElRemoved((el)=>$bf0aa42b5f3ddd7c$var$destroyTree(el));
    $bf0aa42b5f3ddd7c$var$onAttributesAdded((el, attrs)=>{
        $bf0aa42b5f3ddd7c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$bf0aa42b5f3ddd7c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($bf0aa42b5f3ddd7c$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $bf0aa42b5f3ddd7c$var$initTree(el);
    });
    $bf0aa42b5f3ddd7c$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $bf0aa42b5f3ddd7c$var$warnAboutMissingPlugins();
    });
}
var $bf0aa42b5f3ddd7c$var$rootSelectorCallbacks = [];
var $bf0aa42b5f3ddd7c$var$initSelectorCallbacks = [];
function $bf0aa42b5f3ddd7c$var$rootSelectors() {
    return $bf0aa42b5f3ddd7c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $bf0aa42b5f3ddd7c$var$allSelectors() {
    return $bf0aa42b5f3ddd7c$var$rootSelectorCallbacks.concat($bf0aa42b5f3ddd7c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $bf0aa42b5f3ddd7c$var$addRootSelector(selectorCallback) {
    $bf0aa42b5f3ddd7c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $bf0aa42b5f3ddd7c$var$addInitSelector(selectorCallback) {
    $bf0aa42b5f3ddd7c$var$initSelectorCallbacks.push(selectorCallback);
}
function $bf0aa42b5f3ddd7c$var$closestRoot(el, includeInitSelectors = false) {
    return $bf0aa42b5f3ddd7c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $bf0aa42b5f3ddd7c$var$allSelectors() : $bf0aa42b5f3ddd7c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $bf0aa42b5f3ddd7c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (el.parentNode instanceof ShadowRoot) return $bf0aa42b5f3ddd7c$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $bf0aa42b5f3ddd7c$var$findClosest(el.parentElement, callback);
}
function $bf0aa42b5f3ddd7c$var$isRoot(el) {
    return $bf0aa42b5f3ddd7c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $bf0aa42b5f3ddd7c$var$initInterceptors2 = [];
function $bf0aa42b5f3ddd7c$var$interceptInit(callback) {
    $bf0aa42b5f3ddd7c$var$initInterceptors2.push(callback);
}
var $bf0aa42b5f3ddd7c$var$markerDispenser = 1;
function $bf0aa42b5f3ddd7c$var$initTree(el, walker = $bf0aa42b5f3ddd7c$var$walk, intercept = ()=>{}) {
    if ($bf0aa42b5f3ddd7c$var$findClosest(el, (i)=>i._x_ignore)) return;
    $bf0aa42b5f3ddd7c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $bf0aa42b5f3ddd7c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $bf0aa42b5f3ddd7c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $bf0aa42b5f3ddd7c$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $bf0aa42b5f3ddd7c$var$destroyTree(root, walker = $bf0aa42b5f3ddd7c$var$walk) {
    walker(root, (el)=>{
        $bf0aa42b5f3ddd7c$var$cleanupElement(el);
        $bf0aa42b5f3ddd7c$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $bf0aa42b5f3ddd7c$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($bf0aa42b5f3ddd7c$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $bf0aa42b5f3ddd7c$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $bf0aa42b5f3ddd7c$var$tickStack = [];
var $bf0aa42b5f3ddd7c$var$isHolding = false;
function $bf0aa42b5f3ddd7c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $bf0aa42b5f3ddd7c$var$isHolding || setTimeout(()=>{
            $bf0aa42b5f3ddd7c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $bf0aa42b5f3ddd7c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $bf0aa42b5f3ddd7c$var$releaseNextTicks() {
    $bf0aa42b5f3ddd7c$var$isHolding = false;
    while($bf0aa42b5f3ddd7c$var$tickStack.length)$bf0aa42b5f3ddd7c$var$tickStack.shift()();
}
function $bf0aa42b5f3ddd7c$var$holdNextTicks() {
    $bf0aa42b5f3ddd7c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $bf0aa42b5f3ddd7c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $bf0aa42b5f3ddd7c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $bf0aa42b5f3ddd7c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $bf0aa42b5f3ddd7c$var$setClasses(el, value());
    return $bf0aa42b5f3ddd7c$var$setClassesFromString(el, value);
}
function $bf0aa42b5f3ddd7c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $bf0aa42b5f3ddd7c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $bf0aa42b5f3ddd7c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $bf0aa42b5f3ddd7c$var$setStylesFromObject(el, value);
    return $bf0aa42b5f3ddd7c$var$setStylesFromString(el, value);
}
function $bf0aa42b5f3ddd7c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $bf0aa42b5f3ddd7c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $bf0aa42b5f3ddd7c$var$setStyles(el, previousStyles);
    };
}
function $bf0aa42b5f3ddd7c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $bf0aa42b5f3ddd7c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $bf0aa42b5f3ddd7c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$bf0aa42b5f3ddd7c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $bf0aa42b5f3ddd7c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $bf0aa42b5f3ddd7c$var$registerTransitionsFromClassString(el, expression, value);
});
function $bf0aa42b5f3ddd7c$var$registerTransitionsFromClassString(el, classString, stage) {
    $bf0aa42b5f3ddd7c$var$registerTransitionObject(el, $bf0aa42b5f3ddd7c$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $bf0aa42b5f3ddd7c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $bf0aa42b5f3ddd7c$var$registerTransitionObject(el, $bf0aa42b5f3ddd7c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $bf0aa42b5f3ddd7c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $bf0aa42b5f3ddd7c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $bf0aa42b5f3ddd7c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $bf0aa42b5f3ddd7c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $bf0aa42b5f3ddd7c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $bf0aa42b5f3ddd7c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $bf0aa42b5f3ddd7c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $bf0aa42b5f3ddd7c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $bf0aa42b5f3ddd7c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $bf0aa42b5f3ddd7c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $bf0aa42b5f3ddd7c$var$closestHide(parent);
}
function $bf0aa42b5f3ddd7c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $bf0aa42b5f3ddd7c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $bf0aa42b5f3ddd7c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $bf0aa42b5f3ddd7c$var$once(()=>{
        $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $bf0aa42b5f3ddd7c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $bf0aa42b5f3ddd7c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $bf0aa42b5f3ddd7c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                stages.end();
            });
            $bf0aa42b5f3ddd7c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $bf0aa42b5f3ddd7c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $bf0aa42b5f3ddd7c$var$isCloning = false;
function $bf0aa42b5f3ddd7c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$bf0aa42b5f3ddd7c$var$isCloning ? fallback(...args) : callback(...args);
}
function $bf0aa42b5f3ddd7c$var$onlyDuringClone(callback) {
    return (...args)=>$bf0aa42b5f3ddd7c$var$isCloning && callback(...args);
}
var $bf0aa42b5f3ddd7c$var$interceptors = [];
function $bf0aa42b5f3ddd7c$var$interceptClone(callback) {
    $bf0aa42b5f3ddd7c$var$interceptors.push(callback);
}
function $bf0aa42b5f3ddd7c$var$cloneNode(from, to) {
    $bf0aa42b5f3ddd7c$var$interceptors.forEach((i)=>i(from, to));
    $bf0aa42b5f3ddd7c$var$isCloning = true;
    $bf0aa42b5f3ddd7c$var$dontRegisterReactiveSideEffects(()=>{
        $bf0aa42b5f3ddd7c$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $bf0aa42b5f3ddd7c$var$isCloning = false;
}
var $bf0aa42b5f3ddd7c$var$isCloningLegacy = false;
function $bf0aa42b5f3ddd7c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $bf0aa42b5f3ddd7c$var$isCloning = true;
    $bf0aa42b5f3ddd7c$var$isCloningLegacy = true;
    $bf0aa42b5f3ddd7c$var$dontRegisterReactiveSideEffects(()=>{
        $bf0aa42b5f3ddd7c$var$cloneTree(newEl);
    });
    $bf0aa42b5f3ddd7c$var$isCloning = false;
    $bf0aa42b5f3ddd7c$var$isCloningLegacy = false;
}
function $bf0aa42b5f3ddd7c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $bf0aa42b5f3ddd7c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $bf0aa42b5f3ddd7c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $bf0aa42b5f3ddd7c$var$initTree(el, shallowWalker);
}
function $bf0aa42b5f3ddd7c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $bf0aa42b5f3ddd7c$var$effect;
    $bf0aa42b5f3ddd7c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $bf0aa42b5f3ddd7c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $bf0aa42b5f3ddd7c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $bf0aa42b5f3ddd7c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $bf0aa42b5f3ddd7c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $bf0aa42b5f3ddd7c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $bf0aa42b5f3ddd7c$var$bindInputValue(el, value);
            break;
        case "style":
            $bf0aa42b5f3ddd7c$var$bindStyles(el, value);
            break;
        case "class":
            $bf0aa42b5f3ddd7c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $bf0aa42b5f3ddd7c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $bf0aa42b5f3ddd7c$var$bindAttribute(el, name, value);
            break;
    }
}
function $bf0aa42b5f3ddd7c$var$bindInputValue(el, value) {
    if ($bf0aa42b5f3ddd7c$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $bf0aa42b5f3ddd7c$var$safeParseBoolean(el.value) === value;
            else el.checked = $bf0aa42b5f3ddd7c$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($bf0aa42b5f3ddd7c$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$bf0aa42b5f3ddd7c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $bf0aa42b5f3ddd7c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $bf0aa42b5f3ddd7c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $bf0aa42b5f3ddd7c$var$setClasses(el, value);
}
function $bf0aa42b5f3ddd7c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $bf0aa42b5f3ddd7c$var$setStyles(el, value);
}
function $bf0aa42b5f3ddd7c$var$bindAttributeAndProperty(el, name, value) {
    $bf0aa42b5f3ddd7c$var$bindAttribute(el, name, value);
    $bf0aa42b5f3ddd7c$var$setPropertyIfChanged(el, name, value);
}
function $bf0aa42b5f3ddd7c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $bf0aa42b5f3ddd7c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($bf0aa42b5f3ddd7c$var$isBooleanAttr(name)) value = name;
        $bf0aa42b5f3ddd7c$var$setIfChanged(el, name, value);
    }
}
function $bf0aa42b5f3ddd7c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $bf0aa42b5f3ddd7c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $bf0aa42b5f3ddd7c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $bf0aa42b5f3ddd7c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $bf0aa42b5f3ddd7c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $bf0aa42b5f3ddd7c$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $bf0aa42b5f3ddd7c$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $bf0aa42b5f3ddd7c$var$isBooleanAttr(attrName) {
    return $bf0aa42b5f3ddd7c$var$booleanAttributes.has(attrName);
}
function $bf0aa42b5f3ddd7c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $bf0aa42b5f3ddd7c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $bf0aa42b5f3ddd7c$var$getAttributeBinding(el, name, fallback);
}
function $bf0aa42b5f3ddd7c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $bf0aa42b5f3ddd7c$var$dontAutoEvaluateFunctions(()=>{
            return $bf0aa42b5f3ddd7c$var$evaluate(el, binding.expression);
        });
    }
    return $bf0aa42b5f3ddd7c$var$getAttributeBinding(el, name, fallback);
}
function $bf0aa42b5f3ddd7c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($bf0aa42b5f3ddd7c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $bf0aa42b5f3ddd7c$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $bf0aa42b5f3ddd7c$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $bf0aa42b5f3ddd7c$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $bf0aa42b5f3ddd7c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $bf0aa42b5f3ddd7c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $bf0aa42b5f3ddd7c$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($bf0aa42b5f3ddd7c$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($bf0aa42b5f3ddd7c$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($bf0aa42b5f3ddd7c$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $bf0aa42b5f3ddd7c$var$release(reference);
    };
}
function $bf0aa42b5f3ddd7c$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $bf0aa42b5f3ddd7c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($bf0aa42b5f3ddd7c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $bf0aa42b5f3ddd7c$var$stores = {};
var $bf0aa42b5f3ddd7c$var$isReactive = false;
function $bf0aa42b5f3ddd7c$var$store(name, value) {
    if (!$bf0aa42b5f3ddd7c$var$isReactive) {
        $bf0aa42b5f3ddd7c$var$stores = $bf0aa42b5f3ddd7c$var$reactive($bf0aa42b5f3ddd7c$var$stores);
        $bf0aa42b5f3ddd7c$var$isReactive = true;
    }
    if (value === void 0) return $bf0aa42b5f3ddd7c$var$stores[name];
    $bf0aa42b5f3ddd7c$var$stores[name] = value;
    $bf0aa42b5f3ddd7c$var$initInterceptors($bf0aa42b5f3ddd7c$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $bf0aa42b5f3ddd7c$var$stores[name].init();
}
function $bf0aa42b5f3ddd7c$var$getStores() {
    return $bf0aa42b5f3ddd7c$var$stores;
}
// packages/alpinejs/src/binds.js
var $bf0aa42b5f3ddd7c$var$binds = {};
function $bf0aa42b5f3ddd7c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $bf0aa42b5f3ddd7c$var$applyBindingsObject(name, getBindings());
    else $bf0aa42b5f3ddd7c$var$binds[name] = getBindings;
    return ()=>{};
}
function $bf0aa42b5f3ddd7c$var$injectBindingProviders(obj) {
    Object.entries($bf0aa42b5f3ddd7c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $bf0aa42b5f3ddd7c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $bf0aa42b5f3ddd7c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $bf0aa42b5f3ddd7c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $bf0aa42b5f3ddd7c$var$datas = {};
function $bf0aa42b5f3ddd7c$var$data(name, callback) {
    $bf0aa42b5f3ddd7c$var$datas[name] = callback;
}
function $bf0aa42b5f3ddd7c$var$injectDataProviders(obj, context) {
    Object.entries($bf0aa42b5f3ddd7c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $bf0aa42b5f3ddd7c$var$Alpine = {
    get reactive () {
        return $bf0aa42b5f3ddd7c$var$reactive;
    },
    get release () {
        return $bf0aa42b5f3ddd7c$var$release;
    },
    get effect () {
        return $bf0aa42b5f3ddd7c$var$effect;
    },
    get raw () {
        return $bf0aa42b5f3ddd7c$var$raw;
    },
    get transaction () {
        return $bf0aa42b5f3ddd7c$var$transaction;
    },
    version: "3.15.8",
    flushAndStopDeferringMutations: $bf0aa42b5f3ddd7c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $bf0aa42b5f3ddd7c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $bf0aa42b5f3ddd7c$var$disableEffectScheduling,
    startObservingMutations: $bf0aa42b5f3ddd7c$var$startObservingMutations,
    stopObservingMutations: $bf0aa42b5f3ddd7c$var$stopObservingMutations,
    setReactivityEngine: $bf0aa42b5f3ddd7c$var$setReactivityEngine,
    onAttributeRemoved: $bf0aa42b5f3ddd7c$var$onAttributeRemoved,
    onAttributesAdded: $bf0aa42b5f3ddd7c$var$onAttributesAdded,
    closestDataStack: $bf0aa42b5f3ddd7c$var$closestDataStack,
    skipDuringClone: $bf0aa42b5f3ddd7c$var$skipDuringClone,
    onlyDuringClone: $bf0aa42b5f3ddd7c$var$onlyDuringClone,
    addRootSelector: $bf0aa42b5f3ddd7c$var$addRootSelector,
    addInitSelector: $bf0aa42b5f3ddd7c$var$addInitSelector,
    setErrorHandler: $bf0aa42b5f3ddd7c$var$setErrorHandler,
    interceptClone: $bf0aa42b5f3ddd7c$var$interceptClone,
    addScopeToNode: $bf0aa42b5f3ddd7c$var$addScopeToNode,
    deferMutations: $bf0aa42b5f3ddd7c$var$deferMutations,
    mapAttributes: $bf0aa42b5f3ddd7c$var$mapAttributes,
    evaluateLater: $bf0aa42b5f3ddd7c$var$evaluateLater,
    interceptInit: $bf0aa42b5f3ddd7c$var$interceptInit,
    initInterceptors: $bf0aa42b5f3ddd7c$var$initInterceptors,
    injectMagics: $bf0aa42b5f3ddd7c$var$injectMagics,
    setEvaluator: $bf0aa42b5f3ddd7c$var$setEvaluator,
    setRawEvaluator: $bf0aa42b5f3ddd7c$var$setRawEvaluator,
    mergeProxies: $bf0aa42b5f3ddd7c$var$mergeProxies,
    extractProp: $bf0aa42b5f3ddd7c$var$extractProp,
    findClosest: $bf0aa42b5f3ddd7c$var$findClosest,
    onElRemoved: $bf0aa42b5f3ddd7c$var$onElRemoved,
    closestRoot: $bf0aa42b5f3ddd7c$var$closestRoot,
    destroyTree: $bf0aa42b5f3ddd7c$var$destroyTree,
    interceptor: $bf0aa42b5f3ddd7c$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $bf0aa42b5f3ddd7c$var$transition,
    setStyles: // INTERNAL
    $bf0aa42b5f3ddd7c$var$setStyles,
    mutateDom: // INTERNAL
    $bf0aa42b5f3ddd7c$var$mutateDom,
    directive: $bf0aa42b5f3ddd7c$var$directive,
    entangle: $bf0aa42b5f3ddd7c$var$entangle,
    throttle: $bf0aa42b5f3ddd7c$var$throttle,
    debounce: $bf0aa42b5f3ddd7c$var$debounce,
    evaluate: $bf0aa42b5f3ddd7c$var$evaluate,
    evaluateRaw: $bf0aa42b5f3ddd7c$var$evaluateRaw,
    initTree: $bf0aa42b5f3ddd7c$var$initTree,
    nextTick: $bf0aa42b5f3ddd7c$var$nextTick,
    prefixed: $bf0aa42b5f3ddd7c$var$prefix,
    prefix: $bf0aa42b5f3ddd7c$var$setPrefix,
    plugin: $bf0aa42b5f3ddd7c$var$plugin,
    magic: $bf0aa42b5f3ddd7c$var$magic,
    store: $bf0aa42b5f3ddd7c$var$store,
    start: $bf0aa42b5f3ddd7c$var$start,
    clone: $bf0aa42b5f3ddd7c$var$clone,
    cloneNode: // INTERNAL
    $bf0aa42b5f3ddd7c$var$cloneNode,
    // INTERNAL
    bound: $bf0aa42b5f3ddd7c$var$getBinding,
    $data: $bf0aa42b5f3ddd7c$var$scope,
    watch: $bf0aa42b5f3ddd7c$var$watch,
    walk: $bf0aa42b5f3ddd7c$var$walk,
    data: $bf0aa42b5f3ddd7c$var$data,
    bind: $bf0aa42b5f3ddd7c$var$bind2
};
var $bf0aa42b5f3ddd7c$var$alpine_default = $bf0aa42b5f3ddd7c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $bf0aa42b5f3ddd7c$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $bf0aa42b5f3ddd7c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $bf0aa42b5f3ddd7c$var$isBooleanAttr2 = /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$makeMap($bf0aa42b5f3ddd7c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $bf0aa42b5f3ddd7c$var$EMPTY_OBJ = Object.freeze({});
var $bf0aa42b5f3ddd7c$var$EMPTY_ARR = Object.freeze([]);
var $bf0aa42b5f3ddd7c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $bf0aa42b5f3ddd7c$var$hasOwn = (val, key)=>$bf0aa42b5f3ddd7c$var$hasOwnProperty.call(val, key);
var $bf0aa42b5f3ddd7c$var$isArray = Array.isArray;
var $bf0aa42b5f3ddd7c$var$isMap = (val)=>$bf0aa42b5f3ddd7c$var$toTypeString(val) === "[object Map]";
var $bf0aa42b5f3ddd7c$var$isString = (val)=>typeof val === "string";
var $bf0aa42b5f3ddd7c$var$isSymbol = (val)=>typeof val === "symbol";
var $bf0aa42b5f3ddd7c$var$isObject = (val)=>val !== null && typeof val === "object";
var $bf0aa42b5f3ddd7c$var$objectToString = Object.prototype.toString;
var $bf0aa42b5f3ddd7c$var$toTypeString = (value)=>$bf0aa42b5f3ddd7c$var$objectToString.call(value);
var $bf0aa42b5f3ddd7c$var$toRawType = (value)=>{
    return $bf0aa42b5f3ddd7c$var$toTypeString(value).slice(8, -1);
};
var $bf0aa42b5f3ddd7c$var$isIntegerKey = (key)=>$bf0aa42b5f3ddd7c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $bf0aa42b5f3ddd7c$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $bf0aa42b5f3ddd7c$var$camelizeRE = /-(\w)/g;
var $bf0aa42b5f3ddd7c$var$camelize = $bf0aa42b5f3ddd7c$var$cacheStringFunction((str)=>{
    return str.replace($bf0aa42b5f3ddd7c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $bf0aa42b5f3ddd7c$var$hyphenateRE = /\B([A-Z])/g;
var $bf0aa42b5f3ddd7c$var$hyphenate = $bf0aa42b5f3ddd7c$var$cacheStringFunction((str)=>str.replace($bf0aa42b5f3ddd7c$var$hyphenateRE, "-$1").toLowerCase());
var $bf0aa42b5f3ddd7c$var$capitalize = $bf0aa42b5f3ddd7c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $bf0aa42b5f3ddd7c$var$toHandlerKey = $bf0aa42b5f3ddd7c$var$cacheStringFunction((str)=>str ? `on${$bf0aa42b5f3ddd7c$var$capitalize(str)}` : ``);
var $bf0aa42b5f3ddd7c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $bf0aa42b5f3ddd7c$var$targetMap = /* @__PURE__ */ new WeakMap();
var $bf0aa42b5f3ddd7c$var$effectStack = [];
var $bf0aa42b5f3ddd7c$var$activeEffect;
var $bf0aa42b5f3ddd7c$var$ITERATE_KEY = Symbol("iterate");
var $bf0aa42b5f3ddd7c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $bf0aa42b5f3ddd7c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $bf0aa42b5f3ddd7c$var$effect2(fn, options = $bf0aa42b5f3ddd7c$var$EMPTY_OBJ) {
    if ($bf0aa42b5f3ddd7c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $bf0aa42b5f3ddd7c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $bf0aa42b5f3ddd7c$var$stop(effect3) {
    if (effect3.active) {
        $bf0aa42b5f3ddd7c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $bf0aa42b5f3ddd7c$var$uid = 0;
function $bf0aa42b5f3ddd7c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$bf0aa42b5f3ddd7c$var$effectStack.includes(effect3)) {
            $bf0aa42b5f3ddd7c$var$cleanup(effect3);
            try {
                $bf0aa42b5f3ddd7c$var$enableTracking();
                $bf0aa42b5f3ddd7c$var$effectStack.push(effect3);
                $bf0aa42b5f3ddd7c$var$activeEffect = effect3;
                return fn();
            } finally{
                $bf0aa42b5f3ddd7c$var$effectStack.pop();
                $bf0aa42b5f3ddd7c$var$resetTracking();
                $bf0aa42b5f3ddd7c$var$activeEffect = $bf0aa42b5f3ddd7c$var$effectStack[$bf0aa42b5f3ddd7c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $bf0aa42b5f3ddd7c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $bf0aa42b5f3ddd7c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $bf0aa42b5f3ddd7c$var$shouldTrack = true;
var $bf0aa42b5f3ddd7c$var$trackStack = [];
function $bf0aa42b5f3ddd7c$var$pauseTracking() {
    $bf0aa42b5f3ddd7c$var$trackStack.push($bf0aa42b5f3ddd7c$var$shouldTrack);
    $bf0aa42b5f3ddd7c$var$shouldTrack = false;
}
function $bf0aa42b5f3ddd7c$var$enableTracking() {
    $bf0aa42b5f3ddd7c$var$trackStack.push($bf0aa42b5f3ddd7c$var$shouldTrack);
    $bf0aa42b5f3ddd7c$var$shouldTrack = true;
}
function $bf0aa42b5f3ddd7c$var$resetTracking() {
    const last = $bf0aa42b5f3ddd7c$var$trackStack.pop();
    $bf0aa42b5f3ddd7c$var$shouldTrack = last === void 0 ? true : last;
}
function $bf0aa42b5f3ddd7c$var$track(target, type, key) {
    if (!$bf0aa42b5f3ddd7c$var$shouldTrack || $bf0aa42b5f3ddd7c$var$activeEffect === void 0) return;
    let depsMap = $bf0aa42b5f3ddd7c$var$targetMap.get(target);
    if (!depsMap) $bf0aa42b5f3ddd7c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($bf0aa42b5f3ddd7c$var$activeEffect)) {
        dep.add($bf0aa42b5f3ddd7c$var$activeEffect);
        $bf0aa42b5f3ddd7c$var$activeEffect.deps.push(dep);
        if ($bf0aa42b5f3ddd7c$var$activeEffect.options.onTrack) $bf0aa42b5f3ddd7c$var$activeEffect.options.onTrack({
            effect: $bf0aa42b5f3ddd7c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $bf0aa42b5f3ddd7c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $bf0aa42b5f3ddd7c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $bf0aa42b5f3ddd7c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $bf0aa42b5f3ddd7c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$bf0aa42b5f3ddd7c$var$isArray(target)) {
                    add2(depsMap.get($bf0aa42b5f3ddd7c$var$ITERATE_KEY));
                    if ($bf0aa42b5f3ddd7c$var$isMap(target)) add2(depsMap.get($bf0aa42b5f3ddd7c$var$MAP_KEY_ITERATE_KEY));
                } else if ($bf0aa42b5f3ddd7c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$bf0aa42b5f3ddd7c$var$isArray(target)) {
                    add2(depsMap.get($bf0aa42b5f3ddd7c$var$ITERATE_KEY));
                    if ($bf0aa42b5f3ddd7c$var$isMap(target)) add2(depsMap.get($bf0aa42b5f3ddd7c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($bf0aa42b5f3ddd7c$var$isMap(target)) add2(depsMap.get($bf0aa42b5f3ddd7c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $bf0aa42b5f3ddd7c$var$isNonTrackableKeys = /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $bf0aa42b5f3ddd7c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($bf0aa42b5f3ddd7c$var$isSymbol));
var $bf0aa42b5f3ddd7c$var$get2 = /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$createGetter();
var $bf0aa42b5f3ddd7c$var$readonlyGet = /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$createGetter(true);
var $bf0aa42b5f3ddd7c$var$arrayInstrumentations = /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$createArrayInstrumentations();
function $bf0aa42b5f3ddd7c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $bf0aa42b5f3ddd7c$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$bf0aa42b5f3ddd7c$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($bf0aa42b5f3ddd7c$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $bf0aa42b5f3ddd7c$var$pauseTracking();
            const res = $bf0aa42b5f3ddd7c$var$toRaw(this)[key].apply(this, args);
            $bf0aa42b5f3ddd7c$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $bf0aa42b5f3ddd7c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $bf0aa42b5f3ddd7c$var$shallowReadonlyMap : $bf0aa42b5f3ddd7c$var$readonlyMap : shallow ? $bf0aa42b5f3ddd7c$var$shallowReactiveMap : $bf0aa42b5f3ddd7c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $bf0aa42b5f3ddd7c$var$isArray(target);
        if (!isReadonly && targetIsArray && $bf0aa42b5f3ddd7c$var$hasOwn($bf0aa42b5f3ddd7c$var$arrayInstrumentations, key)) return Reflect.get($bf0aa42b5f3ddd7c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($bf0aa42b5f3ddd7c$var$isSymbol(key) ? $bf0aa42b5f3ddd7c$var$builtInSymbols.has(key) : $bf0aa42b5f3ddd7c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $bf0aa42b5f3ddd7c$var$track(target, "get", key);
        if (shallow) return res;
        if ($bf0aa42b5f3ddd7c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$bf0aa42b5f3ddd7c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($bf0aa42b5f3ddd7c$var$isObject(res)) return isReadonly ? $bf0aa42b5f3ddd7c$var$readonly(res) : $bf0aa42b5f3ddd7c$var$reactive2(res);
        return res;
    };
}
var $bf0aa42b5f3ddd7c$var$set2 = /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$createSetter();
function $bf0aa42b5f3ddd7c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $bf0aa42b5f3ddd7c$var$toRaw(value);
            oldValue = $bf0aa42b5f3ddd7c$var$toRaw(oldValue);
            if (!$bf0aa42b5f3ddd7c$var$isArray(target) && $bf0aa42b5f3ddd7c$var$isRef(oldValue) && !$bf0aa42b5f3ddd7c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $bf0aa42b5f3ddd7c$var$isArray(target) && $bf0aa42b5f3ddd7c$var$isIntegerKey(key) ? Number(key) < target.length : $bf0aa42b5f3ddd7c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $bf0aa42b5f3ddd7c$var$toRaw(receiver)) {
            if (!hadKey) $bf0aa42b5f3ddd7c$var$trigger(target, "add", key, value);
            else if ($bf0aa42b5f3ddd7c$var$hasChanged(value, oldValue)) $bf0aa42b5f3ddd7c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $bf0aa42b5f3ddd7c$var$deleteProperty(target, key) {
    const hadKey = $bf0aa42b5f3ddd7c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $bf0aa42b5f3ddd7c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $bf0aa42b5f3ddd7c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$bf0aa42b5f3ddd7c$var$isSymbol(key) || !$bf0aa42b5f3ddd7c$var$builtInSymbols.has(key)) $bf0aa42b5f3ddd7c$var$track(target, "has", key);
    return result;
}
function $bf0aa42b5f3ddd7c$var$ownKeys(target) {
    $bf0aa42b5f3ddd7c$var$track(target, "iterate", $bf0aa42b5f3ddd7c$var$isArray(target) ? "length" : $bf0aa42b5f3ddd7c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $bf0aa42b5f3ddd7c$var$mutableHandlers = {
    get: $bf0aa42b5f3ddd7c$var$get2,
    set: $bf0aa42b5f3ddd7c$var$set2,
    deleteProperty: $bf0aa42b5f3ddd7c$var$deleteProperty,
    has: $bf0aa42b5f3ddd7c$var$has,
    ownKeys: $bf0aa42b5f3ddd7c$var$ownKeys
};
var $bf0aa42b5f3ddd7c$var$readonlyHandlers = {
    get: $bf0aa42b5f3ddd7c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $bf0aa42b5f3ddd7c$var$toReactive = (value)=>$bf0aa42b5f3ddd7c$var$isObject(value) ? $bf0aa42b5f3ddd7c$var$reactive2(value) : value;
var $bf0aa42b5f3ddd7c$var$toReadonly = (value)=>$bf0aa42b5f3ddd7c$var$isObject(value) ? $bf0aa42b5f3ddd7c$var$readonly(value) : value;
var $bf0aa42b5f3ddd7c$var$toShallow = (value)=>value;
var $bf0aa42b5f3ddd7c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $bf0aa42b5f3ddd7c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $bf0aa42b5f3ddd7c$var$toRaw(target);
    const rawKey = $bf0aa42b5f3ddd7c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $bf0aa42b5f3ddd7c$var$track(rawTarget, "get", key);
    !isReadonly && $bf0aa42b5f3ddd7c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $bf0aa42b5f3ddd7c$var$getProto(rawTarget);
    const wrap = isShallow ? $bf0aa42b5f3ddd7c$var$toShallow : isReadonly ? $bf0aa42b5f3ddd7c$var$toReadonly : $bf0aa42b5f3ddd7c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $bf0aa42b5f3ddd7c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $bf0aa42b5f3ddd7c$var$toRaw(target);
    const rawKey = $bf0aa42b5f3ddd7c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $bf0aa42b5f3ddd7c$var$track(rawTarget, "has", key);
    !isReadonly && $bf0aa42b5f3ddd7c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $bf0aa42b5f3ddd7c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $bf0aa42b5f3ddd7c$var$track($bf0aa42b5f3ddd7c$var$toRaw(target), "iterate", $bf0aa42b5f3ddd7c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $bf0aa42b5f3ddd7c$var$add(value) {
    value = $bf0aa42b5f3ddd7c$var$toRaw(value);
    const target = $bf0aa42b5f3ddd7c$var$toRaw(this);
    const proto = $bf0aa42b5f3ddd7c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $bf0aa42b5f3ddd7c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $bf0aa42b5f3ddd7c$var$set$1(key, value) {
    value = $bf0aa42b5f3ddd7c$var$toRaw(value);
    const target = $bf0aa42b5f3ddd7c$var$toRaw(this);
    const { has: has2, get: get3 } = $bf0aa42b5f3ddd7c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $bf0aa42b5f3ddd7c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $bf0aa42b5f3ddd7c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $bf0aa42b5f3ddd7c$var$trigger(target, "add", key, value);
    else if ($bf0aa42b5f3ddd7c$var$hasChanged(value, oldValue)) $bf0aa42b5f3ddd7c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $bf0aa42b5f3ddd7c$var$deleteEntry(key) {
    const target = $bf0aa42b5f3ddd7c$var$toRaw(this);
    const { has: has2, get: get3 } = $bf0aa42b5f3ddd7c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $bf0aa42b5f3ddd7c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $bf0aa42b5f3ddd7c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $bf0aa42b5f3ddd7c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $bf0aa42b5f3ddd7c$var$clear() {
    const target = $bf0aa42b5f3ddd7c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $bf0aa42b5f3ddd7c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $bf0aa42b5f3ddd7c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $bf0aa42b5f3ddd7c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $bf0aa42b5f3ddd7c$var$toRaw(target);
        const wrap = isShallow ? $bf0aa42b5f3ddd7c$var$toShallow : isReadonly ? $bf0aa42b5f3ddd7c$var$toReadonly : $bf0aa42b5f3ddd7c$var$toReactive;
        !isReadonly && $bf0aa42b5f3ddd7c$var$track(rawTarget, "iterate", $bf0aa42b5f3ddd7c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $bf0aa42b5f3ddd7c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $bf0aa42b5f3ddd7c$var$toRaw(target);
        const targetIsMap = $bf0aa42b5f3ddd7c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $bf0aa42b5f3ddd7c$var$toShallow : isReadonly ? $bf0aa42b5f3ddd7c$var$toReadonly : $bf0aa42b5f3ddd7c$var$toReactive;
        !isReadonly && $bf0aa42b5f3ddd7c$var$track(rawTarget, "iterate", isKeyOnly ? $bf0aa42b5f3ddd7c$var$MAP_KEY_ITERATE_KEY : $bf0aa42b5f3ddd7c$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $bf0aa42b5f3ddd7c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$bf0aa42b5f3ddd7c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $bf0aa42b5f3ddd7c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $bf0aa42b5f3ddd7c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $bf0aa42b5f3ddd7c$var$get$1(this, key);
        },
        get size () {
            return $bf0aa42b5f3ddd7c$var$size(this);
        },
        has: $bf0aa42b5f3ddd7c$var$has$1,
        add: $bf0aa42b5f3ddd7c$var$add,
        set: $bf0aa42b5f3ddd7c$var$set$1,
        delete: $bf0aa42b5f3ddd7c$var$deleteEntry,
        clear: $bf0aa42b5f3ddd7c$var$clear,
        forEach: $bf0aa42b5f3ddd7c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $bf0aa42b5f3ddd7c$var$get$1(this, key, false, true);
        },
        get size () {
            return $bf0aa42b5f3ddd7c$var$size(this);
        },
        has: $bf0aa42b5f3ddd7c$var$has$1,
        add: $bf0aa42b5f3ddd7c$var$add,
        set: $bf0aa42b5f3ddd7c$var$set$1,
        delete: $bf0aa42b5f3ddd7c$var$deleteEntry,
        clear: $bf0aa42b5f3ddd7c$var$clear,
        forEach: $bf0aa42b5f3ddd7c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $bf0aa42b5f3ddd7c$var$get$1(this, key, true);
        },
        get size () {
            return $bf0aa42b5f3ddd7c$var$size(this, true);
        },
        has (key) {
            return $bf0aa42b5f3ddd7c$var$has$1.call(this, key, true);
        },
        add: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("add"),
        set: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("set"),
        delete: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("delete"),
        clear: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("clear"),
        forEach: $bf0aa42b5f3ddd7c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $bf0aa42b5f3ddd7c$var$get$1(this, key, true, true);
        },
        get size () {
            return $bf0aa42b5f3ddd7c$var$size(this, true);
        },
        has (key) {
            return $bf0aa42b5f3ddd7c$var$has$1.call(this, key, true);
        },
        add: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("add"),
        set: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("set"),
        delete: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("delete"),
        clear: $bf0aa42b5f3ddd7c$var$createReadonlyMethod("clear"),
        forEach: $bf0aa42b5f3ddd7c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $bf0aa42b5f3ddd7c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $bf0aa42b5f3ddd7c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $bf0aa42b5f3ddd7c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $bf0aa42b5f3ddd7c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$bf0aa42b5f3ddd7c$var$mutableInstrumentations, $bf0aa42b5f3ddd7c$var$readonlyInstrumentations, $bf0aa42b5f3ddd7c$var$shallowInstrumentations, $bf0aa42b5f3ddd7c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$createInstrumentations();
function $bf0aa42b5f3ddd7c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $bf0aa42b5f3ddd7c$var$shallowReadonlyInstrumentations : $bf0aa42b5f3ddd7c$var$shallowInstrumentations : isReadonly ? $bf0aa42b5f3ddd7c$var$readonlyInstrumentations : $bf0aa42b5f3ddd7c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($bf0aa42b5f3ddd7c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $bf0aa42b5f3ddd7c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$createInstrumentationGetter(false, false)
};
var $bf0aa42b5f3ddd7c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $bf0aa42b5f3ddd7c$var$createInstrumentationGetter(true, false)
};
function $bf0aa42b5f3ddd7c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $bf0aa42b5f3ddd7c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $bf0aa42b5f3ddd7c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $bf0aa42b5f3ddd7c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $bf0aa42b5f3ddd7c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $bf0aa42b5f3ddd7c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $bf0aa42b5f3ddd7c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $bf0aa42b5f3ddd7c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $bf0aa42b5f3ddd7c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $bf0aa42b5f3ddd7c$var$targetTypeMap($bf0aa42b5f3ddd7c$var$toRawType(value));
}
function $bf0aa42b5f3ddd7c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $bf0aa42b5f3ddd7c$var$createReactiveObject(target, false, $bf0aa42b5f3ddd7c$var$mutableHandlers, $bf0aa42b5f3ddd7c$var$mutableCollectionHandlers, $bf0aa42b5f3ddd7c$var$reactiveMap);
}
function $bf0aa42b5f3ddd7c$var$readonly(target) {
    return $bf0aa42b5f3ddd7c$var$createReactiveObject(target, true, $bf0aa42b5f3ddd7c$var$readonlyHandlers, $bf0aa42b5f3ddd7c$var$readonlyCollectionHandlers, $bf0aa42b5f3ddd7c$var$readonlyMap);
}
function $bf0aa42b5f3ddd7c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$bf0aa42b5f3ddd7c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $bf0aa42b5f3ddd7c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $bf0aa42b5f3ddd7c$var$toRaw(observed) {
    return observed && $bf0aa42b5f3ddd7c$var$toRaw(observed["__v_raw"]) || observed;
}
function $bf0aa42b5f3ddd7c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$bf0aa42b5f3ddd7c$var$magic("nextTick", ()=>$bf0aa42b5f3ddd7c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$bf0aa42b5f3ddd7c$var$magic("dispatch", (el)=>$bf0aa42b5f3ddd7c$var$dispatch.bind($bf0aa42b5f3ddd7c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$bf0aa42b5f3ddd7c$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $bf0aa42b5f3ddd7c$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$bf0aa42b5f3ddd7c$var$magic("store", $bf0aa42b5f3ddd7c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$bf0aa42b5f3ddd7c$var$magic("data", (el)=>$bf0aa42b5f3ddd7c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$bf0aa42b5f3ddd7c$var$magic("root", (el)=>$bf0aa42b5f3ddd7c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$bf0aa42b5f3ddd7c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $bf0aa42b5f3ddd7c$var$mergeProxies($bf0aa42b5f3ddd7c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $bf0aa42b5f3ddd7c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $bf0aa42b5f3ddd7c$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $bf0aa42b5f3ddd7c$var$globalIdMemo = {};
function $bf0aa42b5f3ddd7c$var$findAndIncrementId(name) {
    if (!$bf0aa42b5f3ddd7c$var$globalIdMemo[name]) $bf0aa42b5f3ddd7c$var$globalIdMemo[name] = 0;
    return ++$bf0aa42b5f3ddd7c$var$globalIdMemo[name];
}
function $bf0aa42b5f3ddd7c$var$closestIdRoot(el, name) {
    return $bf0aa42b5f3ddd7c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $bf0aa42b5f3ddd7c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $bf0aa42b5f3ddd7c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$bf0aa42b5f3ddd7c$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $bf0aa42b5f3ddd7c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $bf0aa42b5f3ddd7c$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $bf0aa42b5f3ddd7c$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$bf0aa42b5f3ddd7c$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $bf0aa42b5f3ddd7c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$bf0aa42b5f3ddd7c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$bf0aa42b5f3ddd7c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$bf0aa42b5f3ddd7c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $bf0aa42b5f3ddd7c$var$warnMissingPluginMagic(name, magicName, slug) {
    $bf0aa42b5f3ddd7c$var$magic(magicName, (el)=>$bf0aa42b5f3ddd7c$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$bf0aa42b5f3ddd7c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $bf0aa42b5f3ddd7c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$bf0aa42b5f3ddd7c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $bf0aa42b5f3ddd7c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $bf0aa42b5f3ddd7c$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $bf0aa42b5f3ddd7c$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $bf0aa42b5f3ddd7c$var$skipDuringClone(()=>{
            $bf0aa42b5f3ddd7c$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $bf0aa42b5f3ddd7c$var$getTarget(expression);
        $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$bf0aa42b5f3ddd7c$var$mutateDom(()=>{
            clone2.remove();
            $bf0aa42b5f3ddd7c$var$destroyTree(clone2);
        }));
});
var $bf0aa42b5f3ddd7c$var$teleportContainerDuringClone = document.createElement("div");
function $bf0aa42b5f3ddd7c$var$getTarget(expression) {
    let target = $bf0aa42b5f3ddd7c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $bf0aa42b5f3ddd7c$var$teleportContainerDuringClone;
    })();
    if (!target) $bf0aa42b5f3ddd7c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $bf0aa42b5f3ddd7c$var$handler = ()=>{};
$bf0aa42b5f3ddd7c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$bf0aa42b5f3ddd7c$var$directive("ignore", $bf0aa42b5f3ddd7c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$bf0aa42b5f3ddd7c$var$directive("effect", $bf0aa42b5f3ddd7c$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($bf0aa42b5f3ddd7c$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $bf0aa42b5f3ddd7c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $bf0aa42b5f3ddd7c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $bf0aa42b5f3ddd7c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $bf0aa42b5f3ddd7c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $bf0aa42b5f3ddd7c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $bf0aa42b5f3ddd7c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $bf0aa42b5f3ddd7c$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($bf0aa42b5f3ddd7c$var$isKeyEvent(event) || $bf0aa42b5f3ddd7c$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($bf0aa42b5f3ddd7c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $bf0aa42b5f3ddd7c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $bf0aa42b5f3ddd7c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $bf0aa42b5f3ddd7c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $bf0aa42b5f3ddd7c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $bf0aa42b5f3ddd7c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $bf0aa42b5f3ddd7c$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $bf0aa42b5f3ddd7c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $bf0aa42b5f3ddd7c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $bf0aa42b5f3ddd7c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $bf0aa42b5f3ddd7c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($bf0aa42b5f3ddd7c$var$isClickEvent(e.type)) return false;
            if ($bf0aa42b5f3ddd7c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $bf0aa42b5f3ddd7c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $bf0aa42b5f3ddd7c$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$bf0aa42b5f3ddd7c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $bf0aa42b5f3ddd7c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $bf0aa42b5f3ddd7c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $bf0aa42b5f3ddd7c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $bf0aa42b5f3ddd7c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($bf0aa42b5f3ddd7c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($bf0aa42b5f3ddd7c$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($bf0aa42b5f3ddd7c$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($bf0aa42b5f3ddd7c$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($bf0aa42b5f3ddd7c$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!el.form._x_pendingModelUpdates) el.form._x_pendingModelUpdates = [];
                el.form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>el.form._x_pendingModelUpdates.splice(el.form._x_pendingModelUpdates.indexOf(syncCallback), 1));
            }
        }
        if (hasEnterModifier) listeners.push($bf0aa42b5f3ddd7c$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $bf0aa42b5f3ddd7c$var$on(el, event, modifiers, (e)=>{
            setValue($bf0aa42b5f3ddd7c$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $bf0aa42b5f3ddd7c$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($bf0aa42b5f3ddd7c$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $bf0aa42b5f3ddd7c$var$on(el.form, "reset", [], (e)=>{
            $bf0aa42b5f3ddd7c$var$nextTick(()=>el._x_model && el._x_model.set($bf0aa42b5f3ddd7c$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $bf0aa42b5f3ddd7c$var$mutateDom(()=>$bf0aa42b5f3ddd7c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $bf0aa42b5f3ddd7c$var$getInputValue(el, modifiers, event, currentValue) {
    return $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($bf0aa42b5f3ddd7c$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $bf0aa42b5f3ddd7c$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $bf0aa42b5f3ddd7c$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$bf0aa42b5f3ddd7c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $bf0aa42b5f3ddd7c$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $bf0aa42b5f3ddd7c$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($bf0aa42b5f3ddd7c$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $bf0aa42b5f3ddd7c$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $bf0aa42b5f3ddd7c$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $bf0aa42b5f3ddd7c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $bf0aa42b5f3ddd7c$var$isNumeric2(number) ? number : rawValue;
}
function $bf0aa42b5f3ddd7c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $bf0aa42b5f3ddd7c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $bf0aa42b5f3ddd7c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$bf0aa42b5f3ddd7c$var$directive("cloak", (el)=>queueMicrotask(()=>$bf0aa42b5f3ddd7c$var$mutateDom(()=>el.removeAttribute($bf0aa42b5f3ddd7c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$bf0aa42b5f3ddd7c$var$addInitSelector(()=>`[${$bf0aa42b5f3ddd7c$var$prefix("init")}]`);
$bf0aa42b5f3ddd7c$var$directive("init", $bf0aa42b5f3ddd7c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$bf0aa42b5f3ddd7c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$bf0aa42b5f3ddd7c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $bf0aa42b5f3ddd7c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$bf0aa42b5f3ddd7c$var$mapAttributes($bf0aa42b5f3ddd7c$var$startingWith(":", $bf0aa42b5f3ddd7c$var$into($bf0aa42b5f3ddd7c$var$prefix("bind:"))));
var $bf0aa42b5f3ddd7c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $bf0aa42b5f3ddd7c$var$injectBindingProviders(bindingProviders);
        let getBindings = $bf0aa42b5f3ddd7c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $bf0aa42b5f3ddd7c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $bf0aa42b5f3ddd7c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $bf0aa42b5f3ddd7c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>$bf0aa42b5f3ddd7c$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$bf0aa42b5f3ddd7c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$bf0aa42b5f3ddd7c$var$directive("bind", $bf0aa42b5f3ddd7c$var$handler2);
function $bf0aa42b5f3ddd7c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$bf0aa42b5f3ddd7c$var$addRootSelector(()=>`[${$bf0aa42b5f3ddd7c$var$prefix("data")}]`);
$bf0aa42b5f3ddd7c$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($bf0aa42b5f3ddd7c$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $bf0aa42b5f3ddd7c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $bf0aa42b5f3ddd7c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $bf0aa42b5f3ddd7c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $bf0aa42b5f3ddd7c$var$injectMagics(data2, el);
    let reactiveData = $bf0aa42b5f3ddd7c$var$reactive(data2);
    $bf0aa42b5f3ddd7c$var$initInterceptors(reactiveData);
    let undo = $bf0aa42b5f3ddd7c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $bf0aa42b5f3ddd7c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $bf0aa42b5f3ddd7c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$bf0aa42b5f3ddd7c$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $bf0aa42b5f3ddd7c$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$bf0aa42b5f3ddd7c$var$isCloning) return false;
    if ($bf0aa42b5f3ddd7c$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$bf0aa42b5f3ddd7c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $bf0aa42b5f3ddd7c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $bf0aa42b5f3ddd7c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$bf0aa42b5f3ddd7c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $bf0aa42b5f3ddd7c$var$parseForExpression(expression);
    let evaluateItems = $bf0aa42b5f3ddd7c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $bf0aa42b5f3ddd7c$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$bf0aa42b5f3ddd7c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                $bf0aa42b5f3ddd7c$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $bf0aa42b5f3ddd7c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($bf0aa42b5f3ddd7c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $bf0aa42b5f3ddd7c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $bf0aa42b5f3ddd7c$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $bf0aa42b5f3ddd7c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $bf0aa42b5f3ddd7c$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                $bf0aa42b5f3ddd7c$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                if (!elForSpot) $bf0aa42b5f3ddd7c$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $bf0aa42b5f3ddd7c$var$reactive(scope2);
            $bf0aa42b5f3ddd7c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $bf0aa42b5f3ddd7c$var$skipDuringClone(()=>$bf0aa42b5f3ddd7c$var$initTree(clone2))();
            });
            if (typeof key === "object") $bf0aa42b5f3ddd7c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $bf0aa42b5f3ddd7c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $bf0aa42b5f3ddd7c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $bf0aa42b5f3ddd7c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $bf0aa42b5f3ddd7c$var$handler3() {}
$bf0aa42b5f3ddd7c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $bf0aa42b5f3ddd7c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$bf0aa42b5f3ddd7c$var$directive("ref", $bf0aa42b5f3ddd7c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$bf0aa42b5f3ddd7c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $bf0aa42b5f3ddd7c$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $bf0aa42b5f3ddd7c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $bf0aa42b5f3ddd7c$var$addScopeToNode(clone2, {}, el);
        $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
            el.after(clone2);
            $bf0aa42b5f3ddd7c$var$skipDuringClone(()=>$bf0aa42b5f3ddd7c$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $bf0aa42b5f3ddd7c$var$mutateDom(()=>{
                $bf0aa42b5f3ddd7c$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$bf0aa42b5f3ddd7c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$bf0aa42b5f3ddd7c$var$setIdRoot(el, name));
});
$bf0aa42b5f3ddd7c$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$bf0aa42b5f3ddd7c$var$mapAttributes($bf0aa42b5f3ddd7c$var$startingWith("@", $bf0aa42b5f3ddd7c$var$into($bf0aa42b5f3ddd7c$var$prefix("on:"))));
$bf0aa42b5f3ddd7c$var$directive("on", $bf0aa42b5f3ddd7c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $bf0aa42b5f3ddd7c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $bf0aa42b5f3ddd7c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$bf0aa42b5f3ddd7c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$bf0aa42b5f3ddd7c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$bf0aa42b5f3ddd7c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$bf0aa42b5f3ddd7c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $bf0aa42b5f3ddd7c$var$warnMissingPluginDirective(name, directiveName, slug) {
    $bf0aa42b5f3ddd7c$var$directive(directiveName, (el)=>$bf0aa42b5f3ddd7c$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$bf0aa42b5f3ddd7c$var$alpine_default.setEvaluator($bf0aa42b5f3ddd7c$var$normalEvaluator);
$bf0aa42b5f3ddd7c$var$alpine_default.setRawEvaluator($bf0aa42b5f3ddd7c$var$normalRawEvaluator);
$bf0aa42b5f3ddd7c$var$alpine_default.setReactivityEngine({
    reactive: $bf0aa42b5f3ddd7c$var$reactive2,
    effect: $bf0aa42b5f3ddd7c$var$effect2,
    release: $bf0aa42b5f3ddd7c$var$stop,
    raw: $bf0aa42b5f3ddd7c$var$toRaw
});
var $bf0aa42b5f3ddd7c$export$b7ee041e4ad2afec = $bf0aa42b5f3ddd7c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $bf0aa42b5f3ddd7c$export$2e2bcd8739ae039 = $bf0aa42b5f3ddd7c$export$b7ee041e4ad2afec;


// src/index.js
var $b4011c647a269e44$var$settings = {
    headers: {},
    mergeStrategy: "replace",
    transitions: false,
    mapDelimiter: ":"
};
var $b4011c647a269e44$var$doMorph = ()=>{
    console.error(`You can't use the "morph" merge without first installing the Alpine "morph" plugin here: https://alpinejs.dev/plugins/morph`);
};
function $b4011c647a269e44$var$Ajax(Alpine) {
    if (Alpine.morph) $b4011c647a269e44$var$doMorph = Alpine.morph;
    Alpine.addInitSelector(()=>`[${Alpine.prefixed("target")}]`);
    Alpine.addInitSelector(()=>`[${Alpine.prefixed("target\\.push")}]`);
    Alpine.addInitSelector(()=>`[${Alpine.prefixed("target\\.replace")}]`);
    Alpine.directive("target", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluateLater: evaluateLater, effect: effect })=>{
        let setTarget = (ids)=>{
            el._ajax_target = el._ajax_target || {};
            let plan = {
                ids: $b4011c647a269e44$var$parseIds(el, ids),
                sync: true,
                focus: !modifiers.includes("nofocus"),
                history: modifiers.includes("push") ? "push" : modifiers.includes("replace") ? "replace" : false
            };
            let statues = modifiers.filter((modifier)=>[
                    "back",
                    "away",
                    "error"
                ].includes(modifier) || parseInt(modifier));
            statues = statues.length ? statues : [
                "xxx"
            ];
            statues.forEach((status)=>{
                if (status.charAt(0) === "3") status = "3xx";
                el._ajax_target[status] = plan;
            });
        };
        if (value === "dynamic") {
            let evaluate = evaluateLater(expression);
            effect(()=>evaluate(setTarget));
        } else setTarget(expression);
    });
    Alpine.directive("headers", (el, { expression: expression }, { evaluateLater: evaluateLater, effect: effect })=>{
        let evaluate = evaluateLater(expression || "{}");
        effect(()=>{
            evaluate((headers)=>{
                el._ajax_headers = headers;
            });
        });
    });
    Alpine.addInitSelector(()=>`[${Alpine.prefixed("merge")}]`);
    Alpine.addInitSelector(()=>`[${Alpine.prefixed("merge\\.transition")}]`);
    Alpine.directive("merge", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluateLater: evaluateLater, effect: effect })=>{
        let setMerge = (strategy)=>{
            el._ajax_strategy = strategy;
            el._ajax_transition = $b4011c647a269e44$var$settings.transitions || modifiers.includes("transition");
        };
        if (value === "dynamic") {
            let evaluate = evaluateLater(expression);
            effect(()=>evaluate(setMerge));
        } else setMerge(expression);
    });
    Alpine.magic("ajax", (el)=>{
        return async (action, options = {})=>{
            let control = {
                el: el,
                target: {
                    "xxx": {
                        ids: $b4011c647a269e44$var$parseIds(el, options.targets || options.target),
                        sync: Boolean(options.sync),
                        history: "history" in options ? options.history : false,
                        focus: "focus" in options ? options.focus : true
                    }
                },
                headers: options.headers || {}
            };
            let method = options.method ? options.method.toUpperCase() : "GET";
            let body = options.body;
            return $b4011c647a269e44$var$send(control, action, method, body);
        };
    });
    let started = false;
    Alpine.ajax = {
        start () {
            if (!started) {
                document.addEventListener("submit", $b4011c647a269e44$var$handleForms);
                document.addEventListener("click", $b4011c647a269e44$var$handleLinks);
                window.addEventListener("popstate", $b4011c647a269e44$var$handleHistory);
                started = true;
            }
        },
        configure: $b4011c647a269e44$var$Ajax.configure,
        stop () {
            document.removeEventListener("submit", $b4011c647a269e44$var$handleForms);
            document.removeEventListener("click", $b4011c647a269e44$var$handleLinks);
            window.removeEventListener("popstate", $b4011c647a269e44$var$handleHistory);
            started = false;
        }
    };
    Alpine.ajax.start();
}
$b4011c647a269e44$var$Ajax.configure = (options)=>{
    $b4011c647a269e44$var$settings = Object.assign($b4011c647a269e44$var$settings, options);
    return $b4011c647a269e44$var$Ajax;
};
var $b4011c647a269e44$var$src_default = $b4011c647a269e44$var$Ajax;
function $b4011c647a269e44$var$handleHistory(event) {
    if (!event.state || !event.state.__ajax) return;
    window.location.reload(true);
}
async function $b4011c647a269e44$var$handleLinks(event) {
    if (event.defaultPrevented || event.which > 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    let link = event?.target.closest("a[href]:not([download]):not([noajax])");
    if (!link || !link._ajax_target || link.isContentEditable || link.origin !== window.location.origin || link.getAttribute("href").startsWith("#") || link.hash && $b4011c647a269e44$var$samePath(link, new URL(document.baseURI))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    let control = {
        el: link,
        target: link._ajax_target,
        headers: link._ajax_headers || {}
    };
    let action = link.getAttribute("href");
    try {
        return await $b4011c647a269e44$var$send(control, action);
    } catch (error) {
        if (error.name === "RenderError") {
            console.warn(error.message);
            window.location.href = link.href;
            return;
        }
        throw error;
    }
}
async function $b4011c647a269e44$var$handleForms(event) {
    if (event.defaultPrevented) return;
    let form = event.target;
    let submitter = event.submitter;
    let method = (submitter?.getAttribute("formmethod") || form.getAttribute("method") || "GET").toUpperCase();
    if (!form || !form._ajax_target || method === "DIALOG" || submitter?.hasAttribute("formnoajax") || submitter?.hasAttribute("formtarget") || form.hasAttribute("noajax") || form.hasAttribute("target")) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    let control = {
        el: form,
        target: form._ajax_target,
        headers: form._ajax_headers || {}
    };
    let body = new FormData(form);
    let enctype = form.getAttribute("enctype");
    let action = form.getAttribute("action");
    if (submitter) {
        enctype = submitter.getAttribute("formenctype") || enctype;
        action = submitter.getAttribute("formaction") || action;
        if (submitter.name) body.append(submitter.name, submitter.value);
    }
    try {
        return await $b4011c647a269e44$var$withSubmitter(submitter, ()=>{
            return $b4011c647a269e44$var$send(control, action, method, body, enctype);
        });
    } catch (error) {
        if (error.name === "RenderError") {
            console.warn(error.message);
            form.setAttribute("noajax", "true");
            form.requestSubmit(submitter);
            return;
        }
        throw error;
    }
}
async function $b4011c647a269e44$var$withSubmitter(submitter, callback) {
    if (!submitter) return await callback();
    let disableEvent = (e)=>e.preventDefault();
    submitter.setAttribute("aria-disabled", "true");
    submitter.addEventListener("click", disableEvent);
    let result;
    try {
        result = await callback();
    } finally{
        submitter.removeAttribute("aria-disabled");
        submitter.removeEventListener("click", disableEvent);
    }
    return result;
}
var $b4011c647a269e44$var$PendingTargets = {
    store: /* @__PURE__ */ new Map(),
    plan (plan, response) {
        plan.ids.forEach((pair)=>{
            let docId = pair[0];
            let el = [
                "_self",
                "_top",
                "_none"
            ].includes(docId) ? document.documentElement : document.getElementById(docId);
            if (!el) return console.warn(`Target [#${docId}] was not found in current document.`);
            el._ajax_id = pair[1];
            this.set(el, response);
        });
        if (plan.sync) {
            let targeted = plan.ids.flat();
            document.querySelectorAll("[x-sync]").forEach((el)=>{
                let id = el.getAttribute("id");
                if (!id) throw new $b4011c647a269e44$var$IDError(el);
                if (targeted.includes(id)) return;
                el._ajax_id = id;
                el._ajax_sync = true;
                this.set(el, response);
            });
        }
    },
    purge (response) {
        this.store.forEach((r, t)=>response === r && this.delete(t));
    },
    get (response) {
        let targets = [];
        this.store.forEach((r, t)=>response === r && targets.push(t));
        return targets;
    },
    set (target, response) {
        target.querySelectorAll("[aria-busy]").forEach((busy)=>{
            this.delete(busy);
        });
        target.setAttribute("aria-busy", "true");
        this.store.set(target, response);
    },
    delete (target) {
        target.removeAttribute("aria-busy");
        this.store.delete(target);
    }
};
var $b4011c647a269e44$var$RequestCache = /* @__PURE__ */ new Map();
async function $b4011c647a269e44$var$send(control, action = "", method = "GET", body = null, enctype = "application/x-www-form-urlencoded") {
    if (!$b4011c647a269e44$var$dispatch(control.el, "ajax:before")) return;
    let plan = control.target.xxx;
    let response = {
        ok: false,
        redirected: false,
        url: "",
        status: "",
        html: "",
        raw: ""
    };
    $b4011c647a269e44$var$PendingTargets.plan(plan, response);
    let referrer = new URL(control.el.closest("[data-source]")?.dataset.source || "", document.baseURI);
    action = new URL(action || referrer, document.baseURI);
    if (body) {
        body = $b4011c647a269e44$var$parseFormData(body);
        if (method === "GET") {
            action.search = $b4011c647a269e44$var$formDataToParams(body).toString();
            body = null;
        } else if (enctype !== "multipart/form-data" && body instanceof FormData) body = $b4011c647a269e44$var$formDataToParams(body);
        else enctype = null;
    }
    let request = {
        action: action.toString(),
        method: method,
        body: body,
        enctype: enctype,
        referrer: referrer.toString(),
        headers: Object.assign({
            "X-Alpine-Request": true,
            "X-Alpine-Target": $b4011c647a269e44$var$PendingTargets.get(response).map((target)=>target._ajax_id).join(" ")
        }, $b4011c647a269e44$var$settings.headers, control.headers)
    };
    if (!request.enctype) delete request.enctype;
    $b4011c647a269e44$var$dispatch(control.el, "ajax:send", request);
    let pending;
    if (request.method === "GET" && $b4011c647a269e44$var$RequestCache.has(request.action)) pending = $b4011c647a269e44$var$RequestCache.get(request.action);
    else {
        pending = fetch(request.action, request).then(async (r)=>{
            let text = await r.text();
            let wrapper = document.createRange().createContextualFragment("<template>" + text + "</template>");
            r.html = wrapper.firstElementChild.content;
            r.raw = text;
            return r;
        });
        $b4011c647a269e44$var$RequestCache.set(request.action, pending);
    }
    await pending.then((r)=>{
        response.ok = r.ok;
        response.redirected = r.redirected;
        response.url = r.url;
        response.status = r.status;
        response.html = r.html;
        response.raw = r.raw;
    });
    if (response.ok) {
        if (response.redirected) {
            $b4011c647a269e44$var$dispatch(control.el, "ajax:redirect", response);
            $b4011c647a269e44$var$RequestCache.set(response.url, pending);
            setTimeout(()=>{
                $b4011c647a269e44$var$RequestCache.delete(response.url);
            }, 5);
        }
        $b4011c647a269e44$var$dispatch(control.el, "ajax:success", response);
    } else $b4011c647a269e44$var$dispatch(control.el, "ajax:error", response);
    $b4011c647a269e44$var$dispatch(control.el, "ajax:sent", response);
    $b4011c647a269e44$var$RequestCache.delete(request.action);
    if (!response.html) {
        $b4011c647a269e44$var$PendingTargets.purge(response);
        return;
    }
    let status = response.redirected ? "3xx" : response.status.toString();
    let isBack = $b4011c647a269e44$var$samePath(new URL(response.url), new URL(request.referrer, document.baseURI));
    let key = [
        response.redirected ? isBack ? "back" : "away" : null,
        status,
        status.charAt(0) + "xx",
        response.ok ? "xxx" : "error",
        "xxx"
    ].find((key2)=>key2 in control.target);
    if (key !== "xxx") {
        plan = control.target[key];
        if (!response.redirected || !isBack || !plan.ids.flat().includes("_self")) {
            $b4011c647a269e44$var$PendingTargets.purge(response);
            $b4011c647a269e44$var$PendingTargets.plan(plan, response);
        }
    }
    if (plan.history) $b4011c647a269e44$var$updateHistory(plan.history, response.url);
    let focused = !plan.focus;
    let renders = $b4011c647a269e44$var$PendingTargets.get(response).map(async (target)=>{
        if (!target.isConnected || target._ajax_id === "_none") {
            $b4011c647a269e44$var$PendingTargets.delete(target);
            return;
        }
        if (target === document.documentElement) {
            window.location.href = response.url;
            return;
        }
        let content = response.html.getElementById(target._ajax_id);
        if (!content) {
            if (target._ajax_sync) return;
            if (!$b4011c647a269e44$var$dispatch(control.el, "ajax:missing", {
                target: target,
                response: response
            })) return;
            if (response.ok) return target.remove();
            throw new $b4011c647a269e44$var$RenderError(target, response.status);
        }
        let strategy = target._ajax_strategy || $b4011c647a269e44$var$settings.mergeStrategy;
        let render2 = async ()=>{
            target = await $b4011c647a269e44$var$merge(strategy, target, content);
            if (target) {
                target.dataset.source = response.url;
                $b4011c647a269e44$var$PendingTargets.delete(target);
                let selectors = [
                    "[x-autofocus]",
                    "[autofocus]"
                ];
                while(!focused && selectors.length){
                    let selector = selectors.shift();
                    if (target.matches(selector)) focused = $b4011c647a269e44$var$focusOn(target);
                    focused = focused || Array.from(target.querySelectorAll(selector)).some((focusable)=>$b4011c647a269e44$var$focusOn(focusable));
                }
            }
            $b4011c647a269e44$var$dispatch(target, "ajax:merged");
            return target;
        };
        if (!$b4011c647a269e44$var$dispatch(target, "ajax:merge", {
            strategy: strategy,
            content: content,
            merge: render2
        })) return;
        return render2();
    });
    let render = await Promise.all(renders);
    $b4011c647a269e44$var$dispatch(control.el, "ajax:after", {
        response: response,
        render: render
    });
    return render;
}
function $b4011c647a269e44$var$parseFormData(data) {
    if (data instanceof FormData) return data;
    if (data instanceof HTMLFormElement) return new FormData(data);
    if (typeof data === "string") return data;
    if (data instanceof ArrayBuffer) return data;
    if (data instanceof DataView) return data;
    if (data instanceof Blob) return data;
    if (data instanceof File) return data;
    if (data instanceof URLSearchParams) return data;
    if (data instanceof ReadableStream) return data;
    const formData = new FormData();
    for(let key in data)if (typeof data[key] === "object") formData.append(key, JSON.stringify(data[key]));
    else formData.append(key, data[key]);
    return formData;
}
function $b4011c647a269e44$var$formDataToParams(body) {
    let params = Array.from(body.entries()).filter(([key, value])=>{
        return !(value instanceof File);
    });
    return new URLSearchParams(params);
}
async function $b4011c647a269e44$var$merge(strategy, target, to) {
    let strategies = {
        before (from, to2) {
            from.before(...to2.childNodes);
            return from;
        },
        replace (from, to2) {
            from.replaceWith(to2);
            return to2;
        },
        update (from, to2) {
            from.replaceChildren(...to2.childNodes);
            return from;
        },
        prepend (from, to2) {
            from.prepend(...to2.childNodes);
            return from;
        },
        append (from, to2) {
            from.append(...to2.childNodes);
            return from;
        },
        after (from, to2) {
            from.after(...to2.childNodes);
            return from;
        },
        morph (from, to2) {
            $b4011c647a269e44$var$doMorph(from, to2);
            return document.getElementById(to2.getAttribute("id"));
        }
    };
    if (!target._ajax_transition || !document.startViewTransition) return strategies[strategy](target, to);
    let transition = document.startViewTransition(()=>{
        target = strategies[strategy](target, to);
        return Promise.resolve();
    });
    await transition.updateCallbackDone;
    return target;
}
function $b4011c647a269e44$var$focusOn(el) {
    if (!el) return false;
    if (!el.getClientRects().length) return false;
    setTimeout(()=>{
        if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0");
        el.focus();
    }, 0);
    return true;
}
function $b4011c647a269e44$var$updateHistory(strategy, url) {
    let strategies = {
        push: ()=>window.history.pushState({
                __ajax: true
            }, "", url),
        replace: ()=>window.history.replaceState({
                __ajax: true
            }, "", url)
    };
    return strategies[strategy]();
}
function $b4011c647a269e44$var$parseIds(el, ids = null) {
    let elId = el.getAttribute("id");
    let parsed = [
        elId
    ];
    if (ids) parsed = Array.isArray(ids) ? ids : ids.split(" ");
    parsed = parsed.filter((id)=>id).map((id)=>{
        let pair = id.split($b4011c647a269e44$var$settings.mapDelimiter).map((id2)=>id2 || elId);
        pair[1] = pair[1] || pair[0];
        return pair;
    });
    if (parsed.length === 0) throw new $b4011c647a269e44$var$IDError(el);
    return parsed;
}
function $b4011c647a269e44$var$dispatch(el, name, detail) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        composed: true,
        cancelable: true
    }));
}
function $b4011c647a269e44$var$samePath(urlA, urlB) {
    return $b4011c647a269e44$var$stripTrailingSlash(urlA.pathname) === $b4011c647a269e44$var$stripTrailingSlash(urlB.pathname);
}
function $b4011c647a269e44$var$stripTrailingSlash(str) {
    return str.replace(/\/$/, "");
}
var $b4011c647a269e44$var$IDError = class extends DOMException {
    constructor(el){
        let description = (el.outerHTML.match(/<[^>]+>/) ?? [])[0] ?? "[Element]";
        super(`${description} is missing an ID to target.`, "IDError");
    }
};
var $b4011c647a269e44$var$RenderError = class extends DOMException {
    constructor(target, status){
        let id = target.getAttribute("id");
        super(`Target [#${id}] was not found in response with status [${status}].`, "RenderError");
    }
};
// builds/module.js
var $b4011c647a269e44$export$2e2bcd8739ae039 = $b4011c647a269e44$var$src_default;


window.Alpine = (0, $bf0aa42b5f3ddd7c$export$2e2bcd8739ae039);
// Define imageModal as a global store
(0, $bf0aa42b5f3ddd7c$export$2e2bcd8739ae039).store('imageModal', {
    show: false,
    imageUrl: '',
    openModal (url) {
        this.imageUrl = url;
        this.show = true;
        document.body.style.overflow = 'hidden'; // Prevent background scrolling when modal is open
    },
    closeModal () {
        this.show = false;
        this.imageUrl = ''; // Clear image URL on close
        document.body.style.overflow = ''; // Restore background scrolling
    }
});
(0, $bf0aa42b5f3ddd7c$export$2e2bcd8739ae039).plugin((0, $b4011c647a269e44$export$2e2bcd8739ae039));
(0, $bf0aa42b5f3ddd7c$export$2e2bcd8739ae039).start();


//# sourceMappingURL=cimatic.io.3eea429e.js.map
